<template>
  <section class="magazine-section">
    <div class="background" />
    <div class="content-container">
      <div class="content content--bg">
        <h2 class="hg-title">{{ $t('theBestTravelStories') }}</h2>
      </div>
    </div>
    <!-- flicking -->
    <client-only>
      <HgCardFlicking v-if="magazineCards">
        <HgFlickingSlide
          v-for="card in magazineCards"
          :key="`content-card-${card.id + Math.floor(Math.random() * 999)}`"
          class="content-card hg-flicking-slide"
        >
          <a :href="card.url" target="_self">
            <HgMagazineCard
              :header="card.tags && card.tags.length ? card.tags[0].name : ''"
              :title="card.title"
              :subtitle="card.subtitle"
              :excerpt="card.excerpt"
              :image-url="card.imageUrl"
              :size="isMobile ? 'small' : 'regular'"
            />
          </a>
        </HgFlickingSlide>
      </HgCardFlicking>
    </client-only>
  </section>
</template>

<script>
export default {
  props: {
    magazineCards: {
      type: Array,
      default: () => []
    },
    isMobile: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped lang="scss">
.magazine-section {
  position: relative;
  margin-top: 2rem;
}

.background {
  position: absolute;
  height: 60%;
  width: 100%;
  z-index: 0;
  top: 0;
  background-color: $teal-40;
}

.content {
  position: relative;
  z-index: 2;
  padding: 0 1.5rem;
  min-width: 220px;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h2 {
    margin: 0.5rem 0;
    border-radius: 0.5rem;
    margin-left: -0.5rem;
    padding-left: 0.5rem;
    padding-top: 1.5rem;
    padding-bottom: 0;
  }
}

@media screen and (min-width: 920px) {
  .background {
    width: 60%;
  }
}
</style>
